import React, { useState } from 'react';

import { not, intersection } from '../../Functions';
import {
  Typography,
  Paper,
  List,
  ListItemButton,
  ListItemIcon,
  Checkbox,
  Grid,
  Button,
  Box,
} from '@mui/material';
import { Artist } from '../../@types/api';

interface Props {
  left: Artist[];
  right: Artist[];
  setRight: any;
  leftTitle: string;
  rightTitle: string;
}
const AddRemove: React.FC<Props> = ({
  left,
  right,
  leftTitle,
  rightTitle,
  setRight,
}) => {
  const [checked, setChecked] = useState<any[]>([]);
  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggleChecked = (value: any) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const listBox = (items: any[], title: string) => (
    <div>
      <Typography variant='button'>{title}</Typography>
      <Paper
        sx={{
          width: '280px',
          p: 0,
          height: '400px',
          overflow: 'auto',
        }}
      >
        <List component='div' role='list'>
          {items.map((artist) => {
            const labelId = `transfer-list-item-${artist.artistId}-label`;
            return (
              <ListItemButton
                key={artist.artistId}
                role='listitem'
                onClick={handleToggleChecked(artist)}
                sx={{ p: 0 }}
              >
                <ListItemIcon sx={{ m: 0, p: 0, minWidth: 'unset' }}>
                  <Checkbox
                    checked={checked?.indexOf(artist) !== -1}
                    tabIndex={-1}
                    disableRipple
                    size='small'
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <Box
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {artist.artistName}
                </Box>
              </ListItemButton>
            );
          })}
        </List>
      </Paper>
    </div>
  );

  return (
    <Grid container spacing={2} alignItems='flex-start'>
      <Grid item>{listBox(not(left, right), leftTitle)}</Grid>
      <Grid item>
        <Grid
          container
          direction='column'
          sx={{ height: '400px' }}
          alignItems='center'
          justifyContent='center'
        >
          <Button
            variant='contained'
            size='small'
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label='move selected right'
            sx={{ my: 1 }}
            color='primary'
          >
            &gt;
          </Button>
          <Button
            variant='contained'
            size='small'
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label='move selected left'
            sx={{ my: 1 }}
            color='secondary'
          >
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>{listBox(right, rightTitle)}</Grid>
    </Grid>
  );
};

export default AddRemove;
